var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { isWeChat } from '../browser';
import wx from '@tencent/jweixin';
/**
 * 微信 sdk 初始化
 * @param params
 * @returns
 */
var weiXinInit = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var ticketInfo;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!isWeChat) {
                    return [2 /*return*/, Promise.reject('Please use WeiXin JS SDK in WeiXin App.')];
                }
                return [4 /*yield*/, params.getTicket()];
            case 1:
                ticketInfo = _a.sent();
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var debug = window.location.href.indexOf('wxapidebug=1') > -1;
                        wx.config({
                            debug: debug,
                            appId: ticketInfo.appId,
                            timestamp: +ticketInfo.timestamp,
                            nonceStr: ticketInfo.nonceStr,
                            signature: ticketInfo.signature,
                            jsApiList: params.apiList,
                            openTagList: params.openTagList, // 选填，需要使用的开放标签列表
                        });
                        // 无论是否异常，都会调用ready，只不过异常时会先调用error后调ready
                        // 如果异常，会掉调用error后reject出去，就不在会走到resolve的逻辑啦
                        wx.ready(function () {
                            console.log('wx sdk ready....');
                            resolve(true);
                            // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                        });
                        wx.error(function (res) {
                            console.error('wx sdk error....', res);
                            reject(res);
                            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                        });
                    })];
        }
    });
}); };
/**
 * 加了代理的微信 sdk
 * 目的：
 * 1. 让调用方不需要关注wx.ready
 * 2. promisify
 */
var proxyWx = new Proxy(wx, {
    get: function (target, prop) {
        // wx 下的方法（除了 config、error、ready外）调用，必须在ready后
        // @ts-ignore
        if (typeof target[prop] === 'function' && ['config', 'error', 'ready'].indexOf(prop) === -1) {
            // 返回promise（用promise代替回调）
            return function (args) {
                return new Promise(function (resolve, reject) {
                    wx.ready(function () {
                        // @ts-ignore
                        target[prop](__assign(__assign({}, args), { 
                            // 执行成功回调函数，并扭转promise状态为成功
                            success: function (res) {
                                resolve(res);
                            }, 
                            // 执行失败回调函数，并扭转promise状态为失败
                            fail: function (res) {
                                reject(res);
                            } }));
                    });
                });
            };
        }
        // @ts-ignore
        return target[prop];
    },
});
export { 
/**
 * 微信sdk初始化
 */
weiXinInit, 
/**
 * 带类型声明的微信对象
 */
wx, 
/**
 * 加了代理后的微信对象（不用ready、且所有api均返回promise）
 */
proxyWx, };
